import Swal from 'sweetalert2'
import { lang } from '../../assets/lang'
import { buttonHtml } from './buttonHtml'
import { addClassToAll, sweetAlertCommonParams, createSelect2DynamicOption, selectedOptionsTextArray } from '../../utils/functions'

export const buttonModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.button_modal_title,
    html: buttonHtml,

    willOpen: () => {
      var page_table_id = window.xitFlowBuilderData.page_table_id
      var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
      const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
      var base_url = window.xitFlowBuilderData.base_url

      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      const elementLabel = $('#new-button-choose-label')
      const elementLabelRemove = $('#new-button-remove-label')
      createSelect2DynamicOption(elementLabel)
      createSelect2DynamicOption(elementLabelRemove)

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_dropdown_postback',
        dataType: 'JSON',
        data: { page_table_id, instagram_bot_addon },
        success:function(response) {
          $("#button-type-postback").html(response.dropdown_str);
          $('#button-type-postback').val(oldData.value || '').trigger('change')
        }
      })

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_label_sequence_dropdown',
        dataType: 'JSON',
        data: { page_table_id, requested_from: 'new_postback', instagram_bot_addon },
        success:function(response) {
          $("#new-button-choose-label").html(response.label_dropdown);
          $("#new-button-remove-label").html(response.label_dropdown);
          $("#new-button-choose-sequence").html(response.drip_dropdown);
          $("#new-button-remove-sequence").html(response.drip_dropdown_remove);

          $('#new-button-choose-label').val(oldData.labelIds || '').trigger('change')
          $('#new-button-remove-label').val(oldData.labelIdsRemove || '').trigger('change')

          if (isSequenceAddonAvailable) {
            $('#new-button-choose-sequence').val(oldData.sequenceIdValue || '').trigger('change')
            $('#new-button-remove-sequence').val(oldData.sequenceIdValueRemove || '').trigger('change')
          }
        }
      })

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_team_and_user',
        dataType: 'JSON',
        data: { page_table_id },
        success:function(response) {
          $("#new-button-conversation-user").html(response.team_dropdown);
          $('#new-button-conversation-user').val(oldData.conversationUserId || '').trigger('change')
          $("#new-button-conversation-group").html(response.role_dropdown);
          $('#new-button-conversation-group').val(oldData.conversationGroupId || '').trigger('change')
        }
      })

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_google_sheets',
        dataType: 'JSON',
        beforeSend: function (xhr) {
            xhr.setRequestHeader('X-CSRF-TOKEN', window.xitFlowBuilderData.csrf_token);
        },
        success:function(response) {
          $("#button-google-sheets").html(response.googleSheets);
          $('#button-google-sheets').val(oldData.googleSheets || '').trigger('change')
        }
      })

      const buttonText = $('#button-button-text')
      const buttonWebhookUrl = $('#new-button-webhook-url')
      const buttonType = $('#button-button-type')

      const postBackType = $('#button-type-postback')
      const postBackTypeGroup = $('#button-type-postback-group')

      const buttonActionTypeGroup = $('#button-action-group')
      const buttonActionType = $('#button-action-type')

      const webUrlType = $('#button-type-weburl')
      const webUrlTypeGroup = $('#button-type-weburl-group')

      const callType = $('#button-type-call')
      const callTypeGroup = $('#button-type-call-group')

      const webviewType = $('#button-type-webview')
      const webviewTypeGroup = $('#button-type-webview-group')
      const onlyForSendMessage = $('.only-for-send-message')
      
      if(oldData.text === 'System default action button')
        oldData.buttonType = 'system_default'

      // Sets old data it there is any
      buttonText.val(oldData.buttonText || '')
      buttonWebhookUrl.val(oldData.buttonWebhookUrl || '')
      buttonType.val(oldData.buttonType || '').trigger('change')

      addClassToAll('d-none', '.button-onDemand-field')

      switch (buttonType.val()) {
        case 'post_back':
          postBackType.val(oldData.value || '').trigger('change')
          postBackTypeGroup.removeClass('d-none')
          break
        case 'system_default':
          buttonActionType.val(oldData.value || '').trigger('change')
          buttonActionTypeGroup.removeClass('d-none')
          break
        case 'web_url':
          webUrlType.val(oldData.value || '')
          webUrlTypeGroup.removeClass('d-none')
          break    
        case 'new_post_back':
          onlyForSendMessage.removeClass('d-none')
          break    
        case 'phone_number':
          callType.val(oldData.value || '')
          callTypeGroup.removeClass('d-none')
          break        
        case 'web_url_full': 
        case 'web_url_compact':
        case 'web_url_tall':
          webviewType.val(oldData.value || '')
          webviewTypeGroup.removeClass('d-none')
          break
        default:        
          break
      }

      buttonType.on('change', function(e) {
        const selectedType = e.target.value
        addClassToAll('d-none', '.button-onDemand-field')

        if(selectedType !== 'new_post_back')
        {
          $('#new-button-choose-sequence').val('').trigger('change')
        }

        if ('post_back' === selectedType) {
          postBackTypeGroup.removeClass('d-none')
        } else if('new_post_back' === selectedType) {
          onlyForSendMessage.removeClass('d-none')
        } else if ('web_url' === selectedType) {
          webUrlTypeGroup.removeClass('d-none')
        } else if ('system_default' === selectedType) {
          buttonActionTypeGroup.removeClass('d-none')
        } else if ('phone_number' === selectedType) {
          callTypeGroup.removeClass('d-none')
        } else if (
          [
            'web_url_full',
            'web_url_compact',
            'web_url_tall',
          ].indexOf(selectedType) > -1
        ) {
          webviewTypeGroup.removeClass('d-none')
          
        }
      })

      $('[data-toggle="tooltip"]').tooltip()
    },

    preConfirm: () => {
      const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
      const buttonText = $('#button-button-text').val()
      const buttonWebhookUrl = $('#new-button-webhook-url').val()
      const buttonType = $('#button-button-type').val()

      if (! buttonText) {
        Swal.showValidationMessage(lang.button_modal_msg_button_name)
        return
      }

      if (! buttonType) {
        Swal.showValidationMessage(lang.button_modal_msg_button_type)
        return
      }

      const data = {
        buttonText: buttonText,
        buttonWebhookUrl: buttonWebhookUrl,
        buttonType: buttonType,
        text: $('#button-button-type option:selected').text()
      }

      if ('post_back' === buttonType) {
        const postbackId = $('#button-type-postback')
        if (! postbackId.val()) {
          Swal.showValidationMessage(lang.button_modal_msg_postback_id)
          return
        }
        data.value = postbackId.val()
        data.postback_text = $('#button-type-postback option:selected').text()
      } else if ('system_default' === buttonType) {
        const postbackId = $('#button-action-type')
        if (! postbackId.val()) {
          Swal.showValidationMessage(lang.button_modal_msg_action_type)
          return
        }
        data.value = postbackId.val()
        data.buttonType = postbackId.val()
        data.postback_text = $('#button-action-type option:selected').text()
      } else if ('web_url' === buttonType) {
        const webUrl = $('#button-type-weburl')
        if (! webUrl.val()) {
          Swal.showValidationMessage(lang.button_modal_msg_web_url)
          return
        }        
        data.value = webUrl.val()
        
      } else if (
        [
          'web_url_full', 
          'web_url_compact', 
          'web_url_tall',
        ].indexOf(buttonType) > -1
      ) {
        const webviewUrl = $('#button-type-webview')
        if (! webviewUrl.val()) {
          Swal.showValidationMessage(lang.button_modal_msg_webview_url)
          return
        }         
        data.value = webviewUrl.val()
      } else if ('phone_number' === buttonType) {
        const callUs = $('#button-type-call')
        if (! callUs.val()) {
          Swal.showValidationMessage(lang.button_modal_msg_mobile)
          return
        } 
        data.value = callUs.val()
      } else {
        const buttonTypeText = $('#button-button-type option:selected').text()
        data.text = buttonTypeText
      }

      const labelIds = $('#new-button-choose-label').val()
      const labelIdTexts = $('#new-button-choose-label option:selected')      
      const labelIdTextsArray = selectedOptionsTextArray(labelIdTexts) 
      data['labelIds'] = labelIds
      data['labelIdTextsArray'] = labelIdTextsArray

      const google_sheets = $('#button-google-sheets').val()
      const google_sheets_text = $('#button-google-sheets option:selected')      
      const google_sheets_array = selectedOptionsTextArray(google_sheets_text) 
      data['googleSheets'] = google_sheets
      data['googleSheetsArray'] = google_sheets_array

      const labelIdsRemove = $('#new-button-remove-label').val()
      const labelIdTextsRemove = $('#new-button-remove-label option:selected')      
      const labelIdTextsArrayRemove = selectedOptionsTextArray(labelIdTextsRemove) 
      data['labelIdsRemove'] = labelIdsRemove
      data['labelIdTextsArrayRemove'] = labelIdTextsArrayRemove
      
      if (isSequenceAddonAvailable) {
        const sequenceIdValue = $('#new-button-choose-sequence').val()
        const sequenceIdText = $('#new-button-choose-sequence option:selected').text()
        data['sequenceIdValue'] = sequenceIdValue
        data['sequenceIdText'] = sequenceIdText

        const sequenceIdValueRemove = $('#new-button-remove-sequence').val()
        const sequenceIdTextRemove = $('#new-button-remove-sequence option:selected').text()
        data['sequenceIdValueRemove'] = sequenceIdValueRemove
        data['sequenceIdTextRemove'] = sequenceIdTextRemove
      }

      const conversationGroupId = $('#new-button-conversation-group').val()
      const conversationGroupText = $('#new-button-conversation-group option:selected').text()
      data['conversationGroupId'] = conversationGroupId
      data['conversationGroupText'] = conversationGroupText

      const conversationUserId = $('#new-button-conversation-user').val()
      const conversationUserText = $('#new-button-conversation-user option:selected').text()
      data['conversationUserId'] = conversationUserId
      data['conversationUserText'] = conversationUserText

      return data
    },    
  })
}